module.exports = __webpack_public_path__ + "static/media/requestCard.59710d55.svg";